import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PAUSE_STATUS } from '../../utils/constants';
import useDidMountEffect from '../../utils/useDidMountEffect';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import Spinner from 'react-bootstrap/Spinner';
import { Chip, useMediaQuery } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { setAlert, setUser } from '../../../redux/actions';
import './creator-settings.css';
import { useHistory } from 'react-router';
import PageHeader from '../../common/PageHeader';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

const CreatorAdvancedSettings = ({
    user
}) => {
    const isMobile = useMediaQuery('(max-width: 899px)');
    const history = useHistory();
    const dispatch = useDispatch();
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const [busy, setBusy] = useState(false);
    const [pauseText, setPauseText] = useState('');
    const [pauseState, setPauseState] = useState();
    const [countTrigger, setCountTrigger] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    const [hasConfirm, setHasConfirm] = useState(false);
    const [watermark, setWatermark] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        like_count: false,
        follower_count: false,
        new_subscriber: false,
        new_tip: false,
    });

    const getUserWatermarkSettings = () => {
        setBusy(true);
        axios.get(`/api/creators/${userInformation.creator.id}`, {
            params: {
                only: 'watermark,pause_text,pause_status'
            }
        })
            .then((response) => {
                setBusy(false);
                setWatermark(response.data.watermark);
                setPauseText(response.data.pause_text);
                setPauseState(response.data.pause_status);
            })
            .catch((error) => {
                console.error({ error });
                setBusy(false);
            });
    };

    const handleWatermark = (e) => {
        handleSubmit(e, !watermark);
        setWatermark(!watermark);
    };

    const handleSubmit = async (e, mark) => {
        e.preventDefault();

        setBusy(true);
        await axios.patch(`/api/users/${userInformation.id}`, {
            watermark: mark,
            action: 'update_watermark'
        })
            .then((response) => {
                setBusy(false);
                dispatch(setUser());
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Watermark settings updated'
                }));
            })
            .catch((error) => {
                console.log({ error });
                setBusy(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to update Watermark settings'
                }));
            });
    };

    useEffect(() => {
        getUserWatermarkSettings();
    }, []);

    useDidMountEffect(() => {
        fillForm();
    }, [user]);

    const fillForm = () => {
        let obj = {};
        Object.keys(state).forEach(key => {
            if (key in user.creator) {
                obj[key] = user.creator[key];
                console.log({ [key]: user.creator[key] });
            }
        });

        setState(obj);
    };

    const handlePauseForm = async (e) => {
        e.preventDefault();
        setBusy(true);
        await axios.patch(`/api/users/${userInformation.id}`, {
            pause_text: pauseText
        }).then((response) => {
            dispatch(setAlert({
                show: true,
                type: 'success',
                body: 'Pause text updated'
            }));
        })
            .catch((error) => {
                console.log({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to update pause text'
                }));
            })
            .finally(() => {
                setBusy(false);
            });
    };


    const doPauseAction = async () => {
        setBusy(true);
        await axios.patch(`/api/creators/${userInformation.creator.id}`, {
            pause_status: pauseState
        })
            .then(response => {
                setBusy(false);
                getUserWatermarkSettings();

                let message = 'Your account has now been Paused';

                if (pauseState == 0) {
                    message = 'Your account status is now Resumed';
                }

                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: message
                }));
            })
            .catch(error => {
                setBusy(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to pause account'
                }));
            });
    };

    const handlePause = (e, pauseStatus = PAUSE_STATUS.PAUSED) => {
        e.preventDefault();
        if (pauseStatus == PAUSE_STATUS.UNPAUSED) {
            setPauseState(PAUSE_STATUS.UNPAUSED);
            setCountTrigger(countTrigger => countTrigger + 1);
        } else {
            // setAlertText('Are you sure to delete your account?');
            setShowAlert(true);
            setHasConfirm(true);
        }
    };

    useDidMountEffect(() => {
        doPauseAction();
    }, [countTrigger]);

    const handleUpdate = async (payload) => {
        await axios.patch(`/api/creators/${user.creator.id}`, {
            ...payload
        })
            .then(response => {
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Update successful'
                }));
            })
            .catch(error => {
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to process request'
                }));
            });
    };

    const handleFollowChange = () => {
        setState({
            ...state,
            follower_count: !state.follower_count
        });
        handleUpdate({ follower_count: !state.follower_count });
    };

    const handleLikeChange = () => {
        setState({
            ...state,
            like_count: !state.like_count
        });

        handleUpdate({ like_count: !state.like_count });
    };

    const handleNewSubscriber = () => {
        setState({
            ...state,
            new_subscriber: !state.new_subscriber
        });
        handleUpdate({ new_subscriber: !state.new_subscriber });
    };

    const handleNewTipChange = () => {
        setState({
            ...state,
            new_tip: !state.new_tip
        });
        handleUpdate({ new_tip: !state.new_tip });
    };


    return (
        <div className="container advanced-settings-container creator-advanced-settings pt-4 mb-4">
            <Grid2
                container
                spacing={!isMobile ? 2 : 0}
            >
                <Grid2 item md={8}>
                    <PageHeader
                        title='Creator Advanced Settings'
                        onBack={() => history.push('/become-creator')}
                        backable={true}
                        containerStyle={{ marginBottom: '15px' }}
                        closePath={'/home'}
                    />

                    <div className="payout-pref-container mb-4">
                        <div className="panel panel-default">
                            <div className="panel-heading refpayout">
                                <span>Profile statistics visible to other users</span>
                            </div>
                            <div className="panel-body">
                                <div className="Chat-wrap">
                                    <p>Show Followers Count
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                name="follower_count"
                                                id="follower_count"
                                                checked={state.follower_count}
                                                onChange={handleFollowChange}
                                                disabled={isLoading}
                                            />
                                            <span className="c_slider round"></span>
                                        </label>
                                    </p>
                                </div>
                                <div className="Chat-wrap"> <span></span>
                                    <p>Show Likes Count
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                name="like_count"
                                                id="like_count"
                                                checked={state.like_count}
                                                onChange={handleLikeChange}
                                                disabled={isLoading}
                                            />
                                            <span className="c_slider round"></span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="payout-pref-container mb-4">
                        <div className="panel panel-default">
                            <div className="panel-heading refpayout">
                                <span>Email Notifications</span>
                            </div>
                            <div className="panel-body">
                                <div className="Chat-wrap">
                                    <p>New Subscriber
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                name="new_subscriber"
                                                id="new_subscriber"
                                                checked={state.new_subscriber}
                                                onChange={handleNewSubscriber}
                                                disabled={isLoading}
                                            />
                                            <span className="c_slider round"></span>
                                        </label>
                                    </p>
                                </div>

                                <div className="Chat-wrap">
                                    <p>New Tip
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                name="new_tip"
                                                id="new_tip"
                                                checked={state.new_tip}
                                                onChange={handleNewTipChange}
                                                disabled={isLoading}
                                            />
                                            <span className="c_slider round"></span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="payout-pref-container mb-4">
                        <div className="panel panel-default">
                            <div className="panel-heading refpayout">
                                <span>Watermarks</span>
                            </div>
                            <div className="panel-body">
                                <form id='watermark' method="post" onSubmit={handleSubmit}>
                                    <input type="hidden" name="watermark_update" value="yes" />
                                    <p style={{ lineHeight: '40px' }}>
                                        Add a watermark <Chip size="small" variant='outlined' color='primary' label={`privaposts.com/${userInformation.login}`} sx={{ '& .MuiChip-label': { color: '#0097fe !important' } }} /> to all image and video files being uploaded. <label className="switch">
                                            <input
                                                onChange={handleWatermark}
                                                type="checkbox"
                                                name="image_watermark"
                                                checked={watermark}
                                                disabled={busy}
                                            />
                                            <span className="c_slider round"></span>
                                        </label>
                                    </p>

                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="payout-pref-container mb-4">
                        <div className="panel panel-default pause-panel">
                            <div className="panel-heading refpayout">
                                <span>Pause Account</span>
                            </div>
                            <div className="panel-body clearfix">
                                <h4>Pause Account</h4>
                                <div>
                                    If you want to take a break and pause the collection of subscriptions {!busy && pauseState == PAUSE_STATUS.UNPAUSED && <b><a href="" className="pause_account_click" onClick={(e) => handlePause(e)} >Click here to pause</a></b>}
                                    {!busy && pauseState == PAUSE_STATUS.PAUSED && <b><a href="" className="pause_account_click" onClick={(e) => handlePause(e, PAUSE_STATUS.UNPAUSED)} href="#">Click here to resume</a></b>}
                                    {busy && <div style={{ display: 'inline' }}><Spinner variant="primary" size="sm" animation="border" /></div>}
                                </div>
                                <p>When your account is paused, the following occurs</p>
                                <ul className="lsit-unstyled fa-ul">
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />People cannot subscribe to you</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />Current subscribers will not be charged any subscription during the paused break period</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You can still post content and current subscribers will have access to your posts.</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You and your subscribers can interact via commend and direct messages</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You can still send PPVs and receive Tips</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />Existing subscribers will see your account is Paused and receive notification</li>
                                </ul><br />
                                <h4>Profile Pause Text</h4>
                                <p>Edit the following text to tell new subscribers when your account is Paused. This will appear at the beginning of your Bio description.</p>
                                <form method="POST" id="pause_text_form" onSubmit={handlePauseForm}>
                                    <input type="hidden" name="save_pause_text" defaultValue="yes" />
                                    <div className="profile_pause_box">
                                        <div className="ppb_input mb-2">
                                            <textarea
                                                onChange={(e) => setPauseText(e.target.value)}
                                                value={pauseText}
                                                name="pause_text"
                                                className="pause_text"
                                                width="100%"></textarea>
                                        </div>
                                        <div className="ppb_buttons">
                                            <button type="submit" className="theme-btn theme-btn-bordered btn btn-primary" disabled={busy}>Save</button>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </form>
                                <h4>Why Pause My Account</h4>
                                <p>If you're inactive and your subscribers are still getting charged, you may find that they may get upset and start requesting refunds. Some may even claim chargebacks with their bank to retireve the funds, as per our terms, the bank deducts a $25 fee for each chargeback. We have no control over this fee, so it is in your interest to communicate your level of activity to your subscribers and to pause your account when you know you will be inactive.</p>
                            </div>
                        </div>
                    </div>
                </Grid2>
                {
                    !isMobile
                        ? <Grid2 item className='' md={4}>
                        </Grid2>
                        : null
                }
            </Grid2>

            {
                showAlert
                    ? <AlertConfirmModal
                        modalTitle="Confirm"
                        modalBody="Are you sure you want to pause your account?"
                        show={showAlert}
                        setShow={setShowAlert}
                        isConfirm={hasConfirm}
                        useFunction={() => {
                            setPauseState(pauseState => !pauseState);
                            setCountTrigger(countTrigger => countTrigger + 1);
                        }}
                    />
                    : null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.user.user
});

export default connect(mapStateToProps)(CreatorAdvancedSettings);